// extracted by mini-css-extract-plugin
var _1 = "CollapseControlled_content__5a966";
var _2 = "CollapseControlled_contentWrapper__d6e94";
var _3 = "CollapseControlled_defaultTitle__5a128";
var _4 = "CollapseControlled_defaultTitleContent__4db18";
var _5 = "CollapseControlled_ghost__063f8";
var _6 = "CollapseControlled_root__693ac";
var _7 = "CollapseControlled_title__f0395";
export { _1 as "content", _2 as "contentWrapper", _3 as "defaultTitle", _4 as "defaultTitleContent", _5 as "ghost", _6 as "root", _7 as "title" }
